/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { connect } from 'react-redux';
import { IVillageListHintSchema } from '../../repositories/countryside-search/entities/entities/VillageListHintSchema';
import { IApplicationState, TTypedThunkDispatch } from '../../types/store';
import { IFeedbackRequest, IFeedbackResponse } from '../../types/feedback';
import { sendFeedbackAction, showFeedbackPopup } from '../../store/feedback/actions';
import { FeedbackBlock } from './index';

export interface IFeedbackProps {
  hint: IVillageListHintSchema;
  isFeedbackPopupOpened: boolean;
  isMobile: boolean;
}

export interface IFeedbackDispatchProps {
  sendFeedbackAction(params: IFeedbackRequest): Promise<IFeedbackResponse>;
  showFeedbackPopup(value: boolean): void;
}

export type TFeedbackProps = IFeedbackProps & IFeedbackDispatchProps;

export function mapStateToProps(state: IApplicationState): IFeedbackProps {
  return {
    hint: state.villageList!.hint!,
    isFeedbackPopupOpened: state.feedback.opened,
    isMobile: state.mobile.isMobileVersion,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IFeedbackDispatchProps {
  return {
    sendFeedbackAction: params => dispatch(sendFeedbackAction(params)),
    showFeedbackPopup: value => dispatch(showFeedbackPopup(value)),
  };
}

export const FeedbackContainer = connect<IFeedbackProps, IFeedbackDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(FeedbackBlock);
